import { Component,OnInit, Renderer2 , Inject, PLATFORM_ID} from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JourneyCustomerComponent } from "./modals/journey-customer/journey-customer.component";
import { APIService } from './services/api.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'chef';
  home_route: boolean = false;
  constructor(private renderer: Renderer2, private modalService: NgbModal, private apiService: APIService,@Inject(PLATFORM_ID) private platformId: Object) {
    // this.instafeeds();
    if (window.location.pathname == '/thank-you') {
      this.home_route = true;
      
      
    }
  }
  ngOnInit(): void {
   
  }
  
  ngAfterViewInit() {
    if (localStorage?.getItem('WTC_USER_LOGIN') == '0' || !localStorage?.getItem('WTC_USER_LOGIN')) {
      // this.openjourney();
    }
    // let loader = this.renderer.selectRootElement('#loader');
    // this.renderer.setStyle(loader, 'display', 'none');
    if(localStorage.getItem('city') == undefined ){
      localStorage.setItem("city","Delhi")
  }
    
  }

  onActivate(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      // Themed scrollbar only on the Diwali pages — see styles.scss.
      const onDiwali = window.location.pathname.startsWith('/diwali-packages');
      document.documentElement.classList.toggle('diwali-theme', onDiwali);
  }
}
    // window.scroll(0, 0);


  openjourney() {
    const modalRef = this.modalService.open(JourneyCustomerComponent, { size: '', windowClass: 'mobileClass', centered: true });
    modalRef.dismissed.subscribe((result) => {
      console.log("dismissed")
    })
  }

  instafeeds() {
    // console.log("instafeeds")
    this.apiService.getAPI('https://v1.nocodeapi.com/wethechefs/instagram/dbwCkDYoBcFVlLEl').then((result) => {
      // console.log(result);
      localStorage?.setItem('insta', JSON.stringify(result.data));
    })
  }

}
